import styled from 'styled-components';

import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import type { PortalLinkData } from 'api/ai-builder/requests';

type AiBuilderLinkPreviewProps = {
  portalLink: PortalLinkData;
};

export function AiBuilderLinkPreview({ portalLink }: AiBuilderLinkPreviewProps) {
  const { name, description, url, imageUrl } = portalLink;
  const hostname = new URL(url).hostname;

  return (
    <LinkCard href={url} target="_blank" rel="noopener noreferrer">
      <BannerImage src={imageUrl} alt={name} />
      <Stack space={2} style={{ padding: pxToRem(12) }}>
        <Text font="regular12" text={hostname} color="textSecondary" />
        <Text font="semibold14" text={name} color="textPrimary" />
        {description && <Text font="regular12" text={description} color="textSecondary" />}
      </Stack>
    </LinkCard>
  );
}

const LinkCard = styled.a({
  display: 'block',
  width: '100%',
  border: `1px solid ${theme.color.border10}`,
  borderRadius: pxToRem(8),
  overflow: 'hidden',
  textDecoration: 'none',
  background: theme.color.backgroundPrimary,
  transition: 'border-color 0.15s ease',
  '&:hover': {
    borderColor: theme.color.border20,
  },
});

const BannerImage = styled.img({
  width: '100%',
  height: pxToRem(120),
  objectFit: 'cover',
  display: 'block',
});
